import { useRef, useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateRegisterData } from '../../../../../redux/actions/userActions';
import { isStepValid, handleSubmitFactory } from './helpers';

export default function useFormStep(formStep, validateField, onSuccess, initialRef = null) {
  const inputRef = useRef(initialRef);
  const isMounted = useRef(true);
  const dispatch = useDispatch();
  const initialForm = useSelector((state) => state.registerStepReducer.steps[formStep]);
  const [form, setForm] = useState(initialForm);
  const [formErrors, setFormErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    isMounted.current = true;
    return () => {
      isMounted.current = false;
    };
  }, []);

  const safeSetIsLoading = (val) => {
    if (isMounted.current) setIsLoading(val);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
    setFormErrors((prev) => ({ ...prev, [name]: validateField(name, value) }));
  };

  const updateRedux = () => dispatch(updateRegisterData(formStep, form));

  const handleSubmit = handleSubmitFactory(
    form,
    validateField,
    setFormErrors,
    isLoading,
    safeSetIsLoading,
    onSuccess,
    updateRedux,
  );

  return {
    form,
    setForm,
    formErrors,
    setFormErrors,
    isLoading,
    inputRef,
    handleChange,
    handleSubmit,
    updateRedux,
    isStepValid: () => isStepValid(form, validateField),
  };
}
